export type LinkActionType = 'EXTERNAL_URL' | 'INTERNAL_BROWSER_URL' | 'WEBVIEW_URL';

export const LINK_ACTION_TYPES: LinkActionType[] = ['EXTERNAL_URL', 'INTERNAL_BROWSER_URL', 'WEBVIEW_URL'];
